import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import environment from '@environments/environment';
import { Resource } from '../types';
import { map, Observable } from 'rxjs';

@Injectable()
export class ResourceService {
  private readonly _http = inject(HttpClient);  
  private readonly _resources = signal<Resource[]>([]);

  getResources(): Observable<Resource[]> {
    const url = `${environment.irisApi}/help/`;
    return this._http.get<Resource[]>(url);
  }

  $resources = this._resources.asReadonly();

  downloadResource(uuid: string): Observable<string> {
    const url = `${environment.irisApi}/help/${uuid}/download/`;
    return this._http
      .get<{ url: string }>(url)
      .pipe(map((response) => response.url));
  }
}
